/**
 * Bypass block — WCAG 2.4.1. Visually hidden until it receives focus, which
 * makes it the first thing a keyboard user reaches on every page.
 */
const SkipLink = () => (
  <a className="skip-link" href="#main-content">
    Skip to main content
  </a>
);

export default SkipLink;
